/* eslint-disable no-nested-ternary */
import React, { useContext, ReactNode } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AuthContext } from 'context/AuthContext';
import { LOGIN, MESSAGES } from 'constants/routes';

const PrivateRoute: React.FC<RouteProps> = ({ children, ...restProps }) => {
  const {
    state: { isAuthenticated },
  } = useContext(AuthContext);

  return (
    <Route
      {...restProps}
      render={(props): ReactNode =>
        isAuthenticated ? (
          props.location.pathname === LOGIN ? (
            <Redirect to={MESSAGES} />
          ) : (
            children
          )
        ) : (
          <Redirect to={LOGIN} />
        )
      }
    />
  );
};

export default PrivateRoute;
